import React from "react";
import JisButton from "../../components/controls/jisButton";
import DynamicIcon from "../../components/dynamicicon";

function JisTable({ columns = [], data = [], actions = [] }) {
  return (
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        overflowX: "auto",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        flex: 1,
        maxHeight: 700,
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <thead style={{ backgroundColor: "var(--background)" }}>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} style={thStyle}>
                {col.label}
              </th>
            ))}
            {actions.length > 0 && <th style={thStyle}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => (
            <tr key={idx} style={idx % 2 === 0 ? rowEvenStyle : rowOddStyle}>
              {columns.map((col, i) => (
                <td key={i} style={tdStyle}>
                  {item[col.key] || "N/A"}
                </td>
              ))}
              {actions.length > 0 && (
                <td style={tdStyle}>
                  {actions.length > 0
                    ? actions?.map((action, i) => (
                        <JisButton
                          key={i}
                          iconPosition="left"
                          icon={<DynamicIcon iname={action.icon} />}
                          variant={action.color || "default"}
                          onClick={() => action.onClick(item)}
                          color={action.color || "default"}
                        >
                          {action.label}
                        </JisButton>
                      ))
                    : "N/A"}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Styles
const thStyle = {
  textAlign: "left",
  padding: "12px",
  borderBottom: "1px solid #ccc",
  fontWeight: "bold",
  fontSize: "14px",
};

const tdStyle = {
  padding: "10px 12px",
  borderBottom: "1px solid #eee",
  fontSize: "14px",
};

const rowEvenStyle = {
  backgroundColor: "var(--background)",
};

const rowOddStyle = {
  backgroundColor: "var(--fade_background)",
};

export default JisTable;
